module.exports = __webpack_public_path__ + "img/tribanco-dark.3add28ff.svg";